import { render, staticRenderFns } from "./Confirmation.vue?vue&type=template&id=2f2dd248&"
import script from "./Confirmation.vue?vue&type=script&lang=js&"
export * from "./Confirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f2dd248')) {
      api.createRecord('2f2dd248', component.options)
    } else {
      api.reload('2f2dd248', component.options)
    }
    module.hot.accept("./Confirmation.vue?vue&type=template&id=2f2dd248&", function () {
      api.rerender('2f2dd248', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Configuration/Sponsors/Confirmation.vue"
export default component.exports